import { observable, runInAction } from 'mobx'
import { createElement } from 'react'
import { toast as hotToast } from 'react-hot-toast'

import { Progress } from './Progress'
import { ToastProgressMessageHandler, ToastProgressRef } from './types'

export const createProgress = (onMessage: ToastProgressMessageHandler): ToastProgressRef => {
    const state = observable({ progress: 0 })
    const setProgress = (progress: number) => {
        runInAction(() => {
            state.progress = progress
        })
    }

    const toastId = hotToast.loading(createElement(Progress, { state, onMessage }), { duration: Infinity })

    return { toastId, setProgress }
}
